import { FormattedMessage } from 'react-intl';
import { Link, NavLink, useLocation } from 'react-router';
import { DefaultUserMenu } from '@rio-cloud/rio-user-menu-component';
import ApplicationHeader from '@rio-cloud/rio-uikit/ApplicationHeader';
import IframeResizer from '@rio-cloud/iframe-resizer';

import { config } from '../../config';
import ServiceInfo from './ServiceInfo';
import { routes } from '../../routes/routes';
import { getSharedSearch, withSearch } from '../../routes/routeHelper';

const AppHeader = () => {
    const environment = import.meta.env.PROD ? 'production' : 'local';
    const { search } = useLocation();
    const sharedSearch = getSharedSearch(search);
    const navItems = [
        {
            key: 'intro',
            route: (
                <NavLink to={withSearch(routes.STATUS, sharedSearch)} viewTransition>
                    <FormattedMessage id='intl-msg:starterTemplate.sublink.status' />
                </NavLink>
            ),
        },
        {
            key: 'activity',
            route: (
                <NavLink to={withSearch(routes.ACTIVITY, sharedSearch)} viewTransition>
                    <FormattedMessage id='intl-msg:starterTemplate.sublink.activity' />
                </NavLink>
            ),
        },
        {
            key: 'account',
            route: (
                <NavLink to={withSearch(routes.ACCOUNT, sharedSearch)} viewTransition>
                    <FormattedMessage id='intl-msg:starterTemplate.sublink.account' />
                </NavLink>
            ),
        },
        {
            key: 'bookings',
            route: (
                <NavLink to={routes.BOOKINGS} viewTransition>
                    <FormattedMessage id='intl-msg:starterTemplate.sublink.ocFmsBookings' />
                </NavLink>
            ),
        },
    ];

    const serviceInfoItem = <ServiceInfo />;
    const userMenuItem = <DefaultUserMenu environment={environment} />;

    return (
        <ApplicationHeader
            label={<FormattedMessage id='intl-msg:starterTemplate.moduleName' />}
            appNavigator={
                <IframeResizer
                    className='iFrameResizer'
                    src={config.backend.MENU_SERVICE}
                    title='Application navigator'
                />
            }
            homeRoute={<Link to={config.homeRoute || ''} />}
            navItems={navItems}
            actionBarItems={[serviceInfoItem, userMenuItem]}
        />
    );
};

export default AppHeader;
